module.exports = __webpack_public_path__ + "img/34-General aging.2951066f.png";